<div class="container">
  <div class="title">
    {{'contact.us.title' | translate}}
  </div>
  <fgbcl-contact-us class="text-primary"></fgbcl-contact-us>
</div>
